// This error contract carries only a fixed safety notice, never a consultation.
const EXPECTED = Object.freeze({
  contract_version: "woundos-emergency-failure-advisory-v1",
  code: "IMMEDIATE_IN_PERSON_ASSESSMENT", urgency: "ED_NOW",
  consultation_available: false, clinical_use_authorized: false,
});

export function isEmergencyFailure(status, payload) {
  if (status !== 503 || !payload || typeof payload !== "object") return false;
  const value = payload.safety_advisory;
  return !!value && !Array.isArray(value) && typeof value === "object"
    && Object.keys(value).length === Object.keys(EXPECTED).length
    && Object.entries(EXPECTED).every(([key, expected]) => value[key] === expected);
}

// Independently admitted transport metadata from the validated server snapshot.
// Used only after the full consultation is rejected; never infer it from prose,
// an unaccepted clinical state, or a non-200 response.
const DELIVERY = Object.freeze({
  contract_version: "woundos-emergency-delivery-advisory-v1",
  code: "IMMEDIATE_IN_PERSON_ASSESSMENT", urgency: "ED_NOW",
  scope: "fixed_notice_if_consultation_unavailable", clinical_use_authorized: false,
});

export function isEmergencyDeliveryFallback(status, payload) {
  if (status !== 200 || !payload || typeof payload !== "object") return false;
  const value = payload.emergency_delivery_advisory;
  return !!value && !Array.isArray(value) && typeof value === "object"
    && Object.keys(value).length === Object.keys(DELIVERY).length
    && Object.entries(DELIVERY).every(([key, expected]) => value[key] === expected);
}
